import { useFormik } from 'formik';
import {Redirect} from "react-router-dom";
import React, { useState } from 'react';
import Container from 'react-bootstrap/Container'
import Paper from '@mui/material/Paper';
import * as Yup from 'yup';
import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Button from '@mui/material/Button';
import Logo from '../components/img/logo2.png'
import {APITextField} from '../components/APITextField';
import {useAuth} from '../services/auth';

const validationSchema = Yup.object({
    email: Yup
        .string('Enter your email')
        .email('Enter a valid email')
        .required('Email is required'),
    password: Yup
        .string('Enter your password')
        .min(8, 'Password should be of minimum 8 characters length')
        .required('Password is required'),
})

export default function Login(value) {
    const {isLogged, LogIn} = useAuth()
    const [errors, setErrors] = useState();
    const [values, setValues] = useState({
        password: '',
        showPassword: false,
    });
    const [loading, setLoading] = useState(false)
    const formik = useFormik({
        initialValues: {
            email: "",
            password: "",
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            console.log(values)
        },
    })
    if (isLogged) {
        return <Redirect to="/licenses" />
        // return <Redirect to="/admin" />
    }

    const handleClick = async () => {
        setErrors(undefined);
        setLoading(true)
        LogIn(formik.values.email, formik.values.password)
        .catch((error) => {
            console.log(error)
            if (error == null){
                setErrors({message: "Falha na Conexão com a API de Autenticação"})
            }else{
                console.log(error.response)
                setErrors(error.data)
            }
            
        }).finally(() => setLoading(false));
    }

    const handleClickShowPassword = () => {
        setValues({
            showPassword: !values.showPassword,
        });
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    
    return (
        <div>
            {
                <form onSubmit={formik.handleSubmit}>
                    <div style={{ backgroundColor: "#1565c0", height: "100vh" }}>
                        <Container fluid="sm" style={{ width: "40%", top: "15rem", position: "relative" }} >
                            <Paper elevation={6} style={{ height: "30rem", minWidth:'33rem' }}>
                                <div style={{ left: '30%', position: 'relative' }}>
                                    <FormControl sx={{ m: 2, width: '25ch' }} variant="outlined">
                                        <div style={{ marginBottom: "2rem" }}>
                                            <img src={Logo} alt="logo-birmind" style={{ maxWidth: "20rem", marginLeft: "1rem" }} />
                                        </div>
                                        <span>Bem vindo ao gerenciador de licenças</span>
                                    </FormControl>
                                </div>
                                <div style={{ left: '30%', position: 'relative', bottom: '5rem' }}>
                                    <FormControl sx={{ m: 2, width: '25ch' }} variant="outlined">
                                        <APITextField
                                            id="email"
                                            name="email"
                                            label="Usuário"
                                            variant="outlined"
                                            value={formik.values.email}
                                            onChange={formik.handleChange}
                                            style={{ top: "5rem" }}
                                            errors={errors && errors.username}
                                        />
                                    </FormControl>
                                </div>
                                <div style={{ left: '30%', position: 'relative' }}>
                                    <FormControl sx={{ m: 2, width: '25ch' }} variant="outlined">
                                        <InputLabel htmlFor="outlined-adornment-password">Senha</InputLabel>
                                        <OutlinedInput
                                            id="password"
                                            name="password"
                                            variant="outlined"
                                            type={values.showPassword ? 'text' : 'password'}
                                            value={formik.values.password}
                                            onChange={formik.handleChange}
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={handleClickShowPassword}
                                                        onMouseDown={handleMouseDownPassword}
                                                        edge="end"
                                                    >
                                                        {values.showPassword ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                        />
                                        {errors && errors.message ?
                                            <span style={{ color: 'red', fontSize: '12px' }}>{errors.message}</span> :
                                            null
                                        }
                                        <FormControl sx={{ m: 2, width: '25ch' }} variant="outlined">
                                            <Button disabled={loading}
                                                onClick={handleClick} type="submit" variant="contained" style={{ right: '1rem' }}>Entrar </Button>
                                        </FormControl>
                                    </FormControl>
                                </div>
                            </Paper>
                        </Container>
                    </div >
                </form>
            }
        </div>
    )
}




